import './style.scss';
import 'air-datepicker';
import 'air-datepicker/src/js/i18n/datepicker.en';

export default eachDatePickerInput;

const POSITION_BOTTOM_RIGHT = 'bottom right';
const POSITION_BOTTOM_LEFT = 'bottom left';

function eachDatePickerInput(inputIndex, DatePickerInput) {
    const $datePickerInput = $(DatePickerInput);
    let lang = $('html')[0].lang;
    const initDate = $datePickerInput.data('date');
    const isEventsCalendar = $datePickerInput.data('events');
    let renderCell;

    if ($datePickerInput.data('init-datepicker')) {
        return true;
    }

    if (isEventsCalendar) {
        renderCell = function(date, cellType) {
            const currentDate = date.getDate();
            const eventDates = window.NLMK.eventsDate || [];
            const stringDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getUTCFullYear()}`;

            // Добавляем ссылку для дат с событием
            /* eslint-disable */
            if (cellType == 'day') {
                for (let i = 0; i < eventDates.length; i++) {
                    if (eventDates[i].date === stringDate) {
                        return {
                            html: `<a href="${eventDates[i].link}" style="color: #2c5697;font-weight: bold;">${currentDate}</a>`,
                        };
                    }
                }
            }
        };
    }

    if (lang != 'ru' && lang != 'en') {
        lang = 'en';
    }

    $datePickerInput.data('init-datepicker', true);

    const minSelector = $datePickerInput.data('min-selector');
    const maxSelector = $datePickerInput.data('max-selector');
    const firstDay = parseInt($datePickerInput.data('first-day'));
    const strStartDate = $datePickerInput.data('startdate'); //в формате dd.mm.yyyy
    const minView = $datePickerInput.data('min-view') || 'days';
    const view = $datePickerInput.data('view') || minView;
    const clearButton = $datePickerInput.data('clear-btn') || false;

    const $minDatePicker = $(minSelector);
    const $maxDatePicker = $(maxSelector);

    const hasMinPair = $minDatePicker.length > 0; 
    const hasMaxPair = $maxDatePicker.length > 0;

    const maxDateAttr = $datePickerInput.data('options-max-date');

    let minDate;
    let maxDate;
    let startDate;

    if (maxDateAttr) {
        const maxDateMatches = maxDateAttr.match(/^(\d{4})-(\d{2})-(\d{2})$/);

        if (maxDateMatches && maxDateMatches[3]) {
            const year = maxDateMatches[1];
            const month = parseInt(maxDateMatches[2]) - 1;
            const date = maxDateMatches[3];

            maxDate = new Date(year, month, date);
        }
    }

    if (hasMinPair) {
        minDate = $minDatePicker.val();
    } else if (hasMaxPair) {
        maxDate = $maxDatePicker.val();
    }

    let position = POSITION_BOTTOM_LEFT;

    if (strStartDate) {
        const startDateItems = strStartDate.split('.');
        const startDateMonth = parseInt(startDateItems[1]) - 1;
        startDate = new Date(startDateItems[2], startDateMonth, startDateItems[0]);
        if (isNaN(startDate)) {
            startDate = new Date();
        }
    } else {
        startDate = new Date();
    }

    const options = {
        autoClose: true,
        minDate,
        maxDate,
        firstDay: !isNaN(firstDay) ? firstDay : 1,
        startDate,
        dateFormat: $datePickerInput.data('date-format') || 'dd.mm.yyyy',
        offset: 0,
        position,
        language: lang,
        view,
        minView,
        clearButton,
        prevHtml:
            '<svg width="19" height="6" viewBox="0 0 19 6" xmlns="http://www.w3.org/2000/svg">\n' +
            '    <path d="M18.507 3H1.49M4 0L1 3.02 3.962 6" fill="none"/>\n' +
            '</svg>',
        nextHtml:
            '<svg height="6" viewBox="0 0 19 6" width="19" xmlns="http://www.w3.org/2000/svg">\n' +
            '    <path d="m.493 3h17.017m-2.51 3 3-3.02-2.962-2.98" fill="none"/>\n' +
            '</svg>',
        navTitles: {
            days: 'MM <i>yyyy</i><b></b>',
        },
        onSelect(fd, date) {
            $datePickerInput.toggleClass('fill', $datePickerInput.val().length > 0).trigger('change', [fd, date]);

            if (hasMinPair) {
                const MinDatePickerInstance = $minDatePicker.data('datepicker');

                MinDatePickerInstance.update({
                    maxDate: date,
                });
            } else if (hasMaxPair) {
                const MaxDatePickerInstance = $maxDatePicker.data('datepicker');

                MaxDatePickerInstance.update({
                    minDate: date,
                });
            }
        },

        onShow(picker, animationCompleted) {
            if (!animationCompleted) {
                const $ui = picker.$datepicker;

                const leftEdge = $ui.offset().left;
                const rightEdge = leftEdge + $ui.width();

                if (rightEdge > innerWidth && position !== POSITION_BOTTOM_RIGHT) {
                    position = POSITION_BOTTOM_RIGHT;

                    picker.update('position', position);
                } else if (leftEdge < 0 && position !== POSITION_BOTTOM_LEFT) {
                    position = POSITION_BOTTOM_LEFT;

                    picker.update('position', position);
                }

                $datePickerInput.addClass('focus');
            }
        },

        onHide(dp, animationCompleted) {
            if (!animationCompleted) {
                $datePickerInput.removeClass('focus');
            }
        },

        onRenderCell: renderCell,
    };

    $datePickerInput.datepicker(options);

    if ($datePickerInput.hasClass('input-text')) {
        options['classes'] = 'datepicker--active'
    }

    // init date
    if (initDate) {
        const arrDate = initDate.split('.');

        setTimeout(() => {
            $datePickerInput.data('datepicker').selectDate(new Date(+arrDate[2], +arrDate[1] - 1, +arrDate[0]));
        }, 50);
    }
}



// WEBPACK FOOTER //
// ./js/main/module/datepicker/picker.js